import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection } from "@components";
import "./JobsCareer.scss";
import { CareerAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { useParams } from "react-router-dom";
import { Accordion, ThumbnailBig } from "../../../common/components";
import MenuCareer from "../MenuCareer";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const JobsCareerContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const JobsCareer = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(true);

  const { id } = useParams();

  useEffect(() => {
    setisLoading(true);
    loadData();
  }, []);

  const loadData = async function () {
    const { data } = await CareerAPI("lowongan");
    setdata(data.data);
    setisLoading(false);
  };
  return (
    <div>
      <TitleComponent title={isLoading ? "" : shortDesc.title} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerLowongan}
            desc={isLoading ? "" : data.deskripsiBannerLowongan}
            img={isLoading ? "" : data.imageBannerDesktopLowongan}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerLowongan}
            desc={isLoading ? "" : data.deskripsiBannerLowongan}
            img={isLoading ? "" : data.imageBannerMobileLowongan}
          />
        </Mobile>
      </Container>

      <JobsCareerContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            {typeof data.blockData != "undefined" && data.blockData !== "" && (
              <div className="row">
                {data.blockData.map((item, index) => {
                  return (
                    <Accordion key={index} title={item.judulAccordionLowongan}>
                      {item.deskripsiAccordionLowongan}
                      {`<a href='${
                        item.linkLowongan
                      }' className="btn btn-primary">${t(
                        "kirim_lamaran"
                      )} <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
  <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
</svg></a>`}
                    </Accordion>
                  );
                })}
              </div>
            )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuCareer active={1} />
          </div>
        </div>
      </JobsCareerContainer>
      <FooterSection currentPage={t("lowongan_pekerjaan")} />
    </div>
  );
};

export default JobsCareer;
